import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { TextAssetCollectionWithRecommendations } from './text-asset-collection-with-recommendations';
import { getTextAssetCollectionConfig } from './pmax-text-asset-collection-config';

export const TextAssetCollections = React.memo((props) => {
  const {
    isOptional, showDeleteButton, renderInlineCopilot, textAssetConfig, validationProps, withInlineRecommendations,
  } = props;
  const i18n = useContext(I18nContext);
  const headlineConfig = useMemo(() => getTextAssetCollectionConfig('headlines', i18n, textAssetConfig), [i18n, textAssetConfig]);
  const longHeadlineConfig = useMemo(() => getTextAssetCollectionConfig('longHeadlines', i18n, textAssetConfig), [i18n, textAssetConfig]);
  const descriptionsConfig = useMemo(() => getTextAssetCollectionConfig('descriptions', i18n, textAssetConfig), [i18n, textAssetConfig]);

  return (
    <div className="text-asset-collections">
      <TextAssetCollectionWithRecommendations
        {...headlineConfig}
        validationProps={validationProps}
        isOptional={isOptional}
        showDeleteButton={showDeleteButton}
        renderInlineCopilot={renderInlineCopilot}
        i18n={i18n}
        withInlineRecommendations={withInlineRecommendations}
      />
      <TextAssetCollectionWithRecommendations
        {...longHeadlineConfig}
        validationProps={validationProps}
        isOptional={isOptional}
        showDeleteButton={showDeleteButton}
        renderInlineCopilot={renderInlineCopilot}
        i18n={i18n}
        withInlineRecommendations={withInlineRecommendations}
      />
      <TextAssetCollectionWithRecommendations
        {...descriptionsConfig}
        validationProps={validationProps}
        isOptional={isOptional}
        showDeleteButton={showDeleteButton}
        renderInlineCopilot={renderInlineCopilot}
        i18n={i18n}
        withInlineRecommendations={withInlineRecommendations}
      />
    </div>);
});

TextAssetCollections.propTypes = {
  isOptional: PropTypes.bool,
  showDeleteButton: PropTypes.bool,
  renderInlineCopilot: PropTypes.func,
  textAssetConfig: PropTypes.shape({
    headlines: PropTypes.shape({}),
    longHeadlines: PropTypes.shape({}),
    descriptions: PropTypes.shape({}),
  }),
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      Headline: PropTypes.shape({}),
      LongHeadlines: PropTypes.shape({}),
      Descriptions: PropTypes.shape({}),
    }),
  }),
  withInlineRecommendations: PropTypes.bool,
};

TextAssetCollections.defaultProps = {
  isOptional: false,
  showDeleteButton: false,
  renderInlineCopilot: null,
  textAssetConfig: {
    headlines: {},
    longHeadlines: {},
    descriptions: {},
  },
  validationProps: {
    data: {
      Headline: {},
      LongHeadlines: {},
      Descriptions: {},
    },
  },
  withInlineRecommendations: false,
};
